import { WidgetOutboundMessage } from "../../types";
import BaseController from "./BaseController";

class OutboundMessagesController extends BaseController {
  static evaluate(
    outboundMessageIds: string[],
    context: { current_url: string; time_on_page: number; locale: string }
  ): Promise<{ outbound_messages: WidgetOutboundMessage[] }> {
    return this.post("messenger/outbound_messages/evaluate", {
      outbound_message_ids: outboundMessageIds,
      context: context,
    });
  }
}

export default OutboundMessagesController;
